export function optimisticPositionUpdate<T extends { id: string }>({
  entity,
  entities,
  newPosition,
  getPosition,
}: {
  entity: T;
  entities: T[];
  newPosition: number;
  getPosition: (entity: T) => number;
}): { id: string; updatedPosition: number }[] {
  const result: { id: string; updatedPosition: number }[] = [
    {
      id: entity.id,
      updatedPosition: newPosition,
    },
  ];

  const oldPosition = getPosition(entity);

  entities
    .filter((entity) => {
      const position = getPosition(entity);

      return (
        Math.min(oldPosition, newPosition) <= position &&
        position <= Math.max(oldPosition, newPosition) &&
        position !== oldPosition
      );
    })
    .forEach((entity) => {
      const position = getPosition(entity);
      const updatedPosition = oldPosition < newPosition ? position - 1 : position + 1;

      result.push({
        id: entity.id,
        updatedPosition,
      });
    });

  return result;
}
